export default "__VITE_ASSET__Xu0IIVy6__"